/* eslint-disable no-undef */
import 'lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.css';

/**
 * Open lightbox of images when main gallery image button is clicked
 */
export default function init() {
  const galleries = [...document.querySelectorAll('.c-gallery')];

  // Loop over galleries and set up lightboxes
  if (galleries.length) {
    galleries.forEach((gallery) => {
      const buttons = [...gallery.querySelectorAll('.c-gallery__button')];
      if (buttons.length) {
        const galleryEl = gallery.querySelector('.js-lightbox-trigger');
        galleryEl.addEventListener('click', () => {
          const imageArr = [];
          let thumbSelected = 0;
          let validIndex = 0;
          // Get image urls to populate lightGallery
          buttons.forEach((button) => {
            if (!button.dataset.lightboxImage) {
              return; // Skip buttons without a lightbox image (e.g., 360-degree view)
            }
            imageArr.push({
              src: button.dataset.lightboxImage,
            });
            // Set initial image to match Flickity thumbnail
            if (button.classList.contains('is-nav-selected')) {
              thumbSelected = validIndex;
            }
            validIndex++;
          });
          lightGallery(galleryEl, {
            dynamic: true,
            dynamicEl: imageArr,
            download: false,
            index: thumbSelected,
          });
          // Destroy the lightbox so it gets rebuilt with the image to match Flickity thumbnail
          buttons.forEach((button) => {
            button.addEventListener('click', () => {
              const lightboxInstance = window.lgData[galleryEl.getAttribute('lg-uid')];
              if (lightboxInstance) {
                lightboxInstance.destroy(true);
              }
            });
          });
        });
      }
    });
  }
}
